import * as React from 'react';
import { deprecatedComponent } from '../react/components/core/deprecated-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
/**
 * @deprecated
 * use <Icon iconType="" /> instead
 **/ const IconShoppingBag_1 = deprecatedComponent({
    displayName: 'IconShoppingBag_1',
    // @ts-ignore
    root: (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
            viewBox: "0 0 38 38",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em"
        }, props), /*#__PURE__*/ React.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.25 12.5984C9.25 12.1842 9.58579 11.8484 10 11.8484H26C26.4142 11.8484 26.75 12.1842 26.75 12.5984V29.2984C26.75 29.7126 26.4142 30.0484 26 30.0484H10C9.58579 30.0484 9.25 29.7126 9.25 29.2984V12.5984ZM10.75 13.3484V28.5484H25.25V13.3484H10.75Z",
            fill: "black"
        }), /*#__PURE__*/ React.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.8 9.44995C16.5142 9.44995 16.25 9.71416 16.25 9.99995V15.1C16.25 15.5142 15.9142 15.85 15.5 15.85C15.0858 15.85 14.75 15.5142 14.75 15.1V9.99995C14.75 8.88574 15.6858 7.94995 16.8 7.94995H19.4C20.5142 7.94995 21.45 8.88574 21.45 9.99995V15.2C21.45 15.6142 21.1142 15.95 20.7 15.95C20.2858 15.95 19.95 15.6142 19.95 15.2V9.99995C19.95 9.71416 19.6858 9.44995 19.4 9.44995H16.8Z",
            fill: "black"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M37.5 28.75C37.5 33.0302 34.0302 36.5 29.75 36.5C25.4698 36.5 22 33.0302 22 28.75C22 24.4698 25.4698 21 29.75 21C34.0302 21 37.5 24.4698 37.5 28.75Z",
            fill: "black"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M29.1186 32.375H30.7329V25.2505H29.3179L27.6738 26.4163V27.7914L29.1186 26.8448V32.375Z",
            fill: "white"
        })),
    description: 'The Inline SVG Icon API is deprecated, use the Icon component instead'
});

export { IconShoppingBag_1 };
